/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRemoteSessionClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRemoteSessionClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRemoteSessionClientSecurity = {
  option1?: GetRemoteSessionClientSecurityOption1 | undefined;
  option2?: GetRemoteSessionClientSecurityOption2 | undefined;
};

export type GetRemoteSessionClientRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRemoteSessionClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRemoteSessionClientSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetRemoteSessionClientSecurityOption1$Outbound,
    GetRemoteSessionClientSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getRemoteSessionClientSecurityOption1ToJSON(
  getRemoteSessionClientSecurityOption1: GetRemoteSessionClientSecurityOption1,
): string {
  return JSON.stringify(
    GetRemoteSessionClientSecurityOption1$outboundSchema.parse(
      getRemoteSessionClientSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRemoteSessionClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRemoteSessionClientSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetRemoteSessionClientSecurityOption2$Outbound,
    GetRemoteSessionClientSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getRemoteSessionClientSecurityOption2ToJSON(
  getRemoteSessionClientSecurityOption2: GetRemoteSessionClientSecurityOption2,
): string {
  return JSON.stringify(
    GetRemoteSessionClientSecurityOption2$outboundSchema.parse(
      getRemoteSessionClientSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRemoteSessionClientSecurity$Outbound = {
  Option1?: GetRemoteSessionClientSecurityOption1$Outbound | undefined;
  Option2?: GetRemoteSessionClientSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRemoteSessionClientSecurity$outboundSchema: z.ZodMiniType<
  GetRemoteSessionClientSecurity$Outbound,
  GetRemoteSessionClientSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRemoteSessionClientSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRemoteSessionClientSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRemoteSessionClientSecurityToJSON(
  getRemoteSessionClientSecurity: GetRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    GetRemoteSessionClientSecurity$outboundSchema.parse(
      getRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type GetRemoteSessionClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRemoteSessionClientRequest$outboundSchema: z.ZodMiniType<
  GetRemoteSessionClientRequest$Outbound,
  GetRemoteSessionClientRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRemoteSessionClientRequestToJSON(
  getRemoteSessionClientRequest: GetRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    GetRemoteSessionClientRequest$outboundSchema.parse(
      getRemoteSessionClientRequest,
    ),
  );
}
